import { Bell, CreditCard, KeyRound, Palette, Shield, Ticket, UserRound } from "lucide-react";

/** Your pages, in order. Profile is first, so it is what `/settings` opens on a wide screen. */
export const SETTINGS_SECTIONS = [
  { id: "profile", label: "Profile", icon: UserRound },
  { id: "account", label: "Account", icon: KeyRound },
  { id: "billing", label: "Billing", icon: CreditCard },
  { id: "appearance", label: "Appearance", icon: Palette },
  { id: "notifications", label: "Notifications", icon: Bell },
  { id: "privacy", label: "Privacy", icon: Shield },
  { id: "invites", label: "Invites", icon: Ticket },
] as const;

export type SettingsSectionId = (typeof SETTINGS_SECTIONS)[number]["id"];

/** The section a URL names, or undefined for `/settings` itself or a name that isn't one. */
export function settingsSectionFrom(value: unknown): SettingsSectionId | undefined {
  return SETTINGS_SECTIONS.find(section => section.id === value)?.id;
}
